import React from "react";
import { DropdownItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import store from "@pages/Statistics/store";

import ExportCsvToExcel from "@components/Common/ExportCsvToExcel";

export function DownloadAllExcelDropdownItem({ filename }: DropdownItemProps) {
    const { t } = useTranslation();

    const snapshot = useSnapshot(store);

    const data = snapshot[snapshot.section].all.excel;

    return (
        <DropdownItem>
            <ExportCsvToExcel data={data} filename={filename}>
                <div className="btn p-0">
                    {t("Download all in excel format")}
                </div>
            </ExportCsvToExcel>
        </DropdownItem>
    );
}
